import { configureStore, combineReducers } from "@reduxjs/toolkit";

import trainingsReducer from "../reducers/trainingReducer";
import loggedInUserReducer from "../reducers/loggedInUserReducer";
import userListReducer from "../reducers/userListReducer";
import weeklySummaryReducer from "../reducers/weeklySummaryReducer";
import trainingPeriodsReducer from "../reducers/trainingPeriodReducer";

// Root reducer combining all slices
const rootReducer = combineReducers({
  loggedInUser: loggedInUserReducer,
  userList: userListReducer,
  trainingList: trainingsReducer,
  weeklySummaryList: weeklySummaryReducer,
  trainingPeriods: trainingPeriodsReducer,
});

// Configure the Redux store
const store = configureStore({
  reducer: rootReducer,
 // middleware: (getDefaultMiddleware) =>
 //   getDefaultMiddleware().concat(logMiddleware),
});

// Export RootState and AppDispatch types for use in hooks
export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch;

export default store;
